var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateAssessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 148,
    viewBox: "0 0 170 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.524 33.6442C141.445 23.2729 146.163 11.7074 154.868 4.70631C156.628 3.29205 159.052 1.5031 160.561 0.0297852C156.444 0.137713 151.628 0.580624 147.516 0.83517C137.595 1.4471 96.1303 4.00682 85.3192 4.67373C78.3008 5.10748 71.2825 5.54021 64.2641 5.97395C56.0698 6.47999 49.4943 15.5133 45.8675 22.0379C41.7765 29.3963 39.4255 37.6202 37.8554 45.8502C35.7274 57.0064 33.3398 111.203 32.7828 116.222C31.7962 125.104 28.3008 139.317 17.0254 139.413C21.5522 139.412 106.709 140.022 113.339 140.016C121.074 140.009 125.628 133.887 128.209 127.289C131.373 119.202 132.206 84.2378 132.63 75.1749C133.056 66.0917 137.207 38.3227 138.524 33.6442Z",
    fill: "url(#paint0_radial_1515_3766)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.524 33.6442C141.445 23.2729 146.163 11.7074 154.868 4.70631C156.628 3.29205 159.052 1.5031 160.561 0.0297852C156.444 0.137713 151.628 0.580624 147.516 0.83517C137.595 1.4471 96.1303 4.00682 85.3192 4.67373C78.3008 5.10748 71.2825 5.54021 64.2641 5.97395C56.0698 6.47999 49.4943 15.5133 45.8675 22.0379C41.7765 29.3963 39.4255 37.6202 37.8554 45.8502C35.7274 57.0064 33.3398 111.203 32.7828 116.222C31.7962 125.104 28.3008 139.317 17.0254 139.413C21.5522 139.412 106.709 140.022 113.339 140.016C121.074 140.009 125.628 133.887 128.209 127.289C131.373 119.202 132.206 84.2378 132.63 75.1749C133.056 66.0917 137.207 38.3227 138.524 33.6442Z",
    fill: "url(#paint1_linear_1515_3766)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.042 146.252C106.636 145.246 103.672 142.587 101.262 138.846C99.4764 136.074 97.938 133.095 97.3698 129.826C96.7945 126.521 97.5602 124.086 100.74 122.291C97.5236 122.296 5.727 123.108 4.35041 123.12C1.50357 123.145 0.0587621 125.999 0.00276192 128.473C-0.0532383 130.962 0.75011 133.477 1.70619 135.747C3.07157 138.989 5.20671 142.03 8.04337 144.145C10.5471 146.013 13.8236 147.127 16.9953 147.135C16.9953 147.135 113.991 147.367 114.001 147.367C112.798 147.049 112.092 146.491 111.042 146.252Z",
    fill: "url(#paint2_linear_1515_3766)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164.566 2.59135C163.776 0.702618 161.664 -0.602696 159.658 0.284143C156.083 1.86946 152.889 4.47296 150.062 7.83094C143.653 15.4419 139.901 25.4466 137.361 34.9462C135.104 43.3839 133.784 52.1811 132.998 60.8743C132.423 67.2288 132.107 73.6159 131.88 79.9928C131.56 88.963 131.412 97.9455 130.946 106.91C130.59 113.766 129.957 121.275 127.33 127.687C124.257 135.187 112.368 145.69 106.398 134.256C104.853 131.296 104.999 127.949 103.881 124.887C103.54 123.954 102.948 122.933 102.009 122.505C99.4326 121.334 97.0256 124.299 96.6723 126.514C95.8577 131.626 98.9102 138.135 102.246 141.924C104.511 144.498 107.844 146.506 111.215 147.131C114.106 147.668 117.472 147.264 120.212 146.207C126.673 143.717 131.263 137.874 133.946 131.682C136.111 126.687 137.236 121.109 137.857 115.72C139.205 104.026 139.039 92.1846 139.456 80.4337C139.677 74.2095 139.982 67.9823 140.54 61.7785C141.265 53.7165 142.413 45.6351 144.289 37.7564C146.211 29.6822 149.12 20.8393 154.499 14.3677C156.881 11.5025 159.652 9.26556 162.887 7.82686C164.993 6.89013 165.36 4.48925 164.566 2.59135Z",
    fill: "url(#paint3_linear_1515_3766)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4372 30.9389C81.8724 30.9389 79.7678 28.8862 79.7158 26.3112C79.6629 23.7026 81.7339 21.5441 84.3435 21.4911L114.443 21.0116C117.051 20.9637 119.21 23.0296 119.263 25.6382C119.316 28.2468 117.245 30.4053 114.637 30.4583L84.5369 30.9378C84.5033 30.9389 84.4697 30.9389 84.4372 30.9389Z",
    fill: "url(#paint4_linear_1515_3766)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3965 32.3775C70.9324 32.3775 73.7988 29.511 73.7988 25.9751C73.7988 22.4392 70.9324 19.5728 67.3965 19.5728C63.8606 19.5728 60.9941 22.4392 60.9941 25.9751C60.9941 29.511 63.8606 32.3775 67.3965 32.3775Z",
    fill: "url(#paint5_radial_1515_3766)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4453 54.4468C63.9812 54.4468 66.8477 51.5804 66.8477 48.0444C66.8477 44.5085 63.9812 41.6421 60.4453 41.6421C56.9094 41.6421 54.043 44.5085 54.043 48.0444C54.043 51.5804 56.9094 54.4468 60.4453 54.4468Z",
    fill: "url(#paint6_radial_1515_3766)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7949 76.5147C61.3309 76.5147 64.1973 73.6482 64.1973 70.1123C64.1973 66.5764 61.3309 63.71 57.7949 63.71C54.259 63.71 51.3926 66.5764 51.3926 70.1123C51.3926 73.6482 54.259 76.5147 57.7949 76.5147Z",
    fill: "url(#paint7_radial_1515_3766)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1328 98.583C60.6687 98.583 63.5352 95.7166 63.5352 92.1807C63.5352 88.6448 60.6687 85.7783 57.1328 85.7783C53.5969 85.7783 50.7305 88.6448 50.7305 92.1807C50.7305 95.7166 53.5969 98.583 57.1328 98.583Z",
    fill: "url(#paint8_radial_1515_3766)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.486 53.0081C74.9222 53.0081 72.8176 50.9565 72.7647 48.3805C72.7117 45.7719 74.7827 43.6144 77.3913 43.5604L107.49 43.0808C110.101 43.0218 112.256 45.0989 112.31 47.7075C112.363 50.316 110.292 52.4736 107.683 52.5275L77.5848 53.0071C77.5522 53.0081 77.5196 53.0081 77.486 53.0081Z",
    fill: "url(#paint9_linear_1515_3766)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8356 75.0757C72.2708 75.0757 70.1672 73.0241 70.1143 70.4481C70.0613 67.8395 72.1323 65.6819 74.7409 65.628L104.839 65.1484C107.451 65.0965 109.606 67.1665 109.66 69.7751C109.713 72.3836 107.642 74.5412 105.033 74.5951L74.9344 75.0747C74.9018 75.0757 74.8692 75.0757 74.8356 75.0757Z",
    fill: "url(#paint10_linear_1515_3766)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1735 97.1456C71.6097 97.1456 69.5051 95.0939 69.4522 92.5179C69.3992 89.9093 71.4702 87.7518 74.0788 87.6978L97.5582 87.2182C100.17 87.1541 102.324 89.2363 102.378 91.8449C102.431 94.4535 100.36 96.611 97.7516 96.665L74.2723 97.1445C74.2397 97.1445 74.2061 97.1456 74.1735 97.1456Z",
    fill: "url(#paint11_linear_1515_3766)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M132.465 126.268C153.194 126.268 169.998 109.464 169.998 88.7345C169.998 68.0054 153.194 51.2012 132.465 51.2012C111.736 51.2012 94.9316 68.0054 94.9316 88.7345C94.9316 109.464 111.736 126.268 132.465 126.268Z",
    fill: "url(#paint12_radial_1515_3766)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M132.465 126.268C153.194 126.268 169.998 109.464 169.998 88.7345C169.998 68.0054 153.194 51.2012 132.465 51.2012C111.736 51.2012 94.9316 68.0054 94.9316 88.7345C94.9316 109.464 111.736 126.268 132.465 126.268Z",
    fill: "url(#paint13_radial_1515_3766)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M105.242 80.2382C104.686 81.5303 103.922 82.6604 102.722 82.522C101.819 82.4181 101.238 81.4956 101.017 80.6149C100.485 78.4879 101.273 76.2561 102.284 74.3113C104.381 70.2793 107.468 66.4438 111.237 63.8678C111.834 63.4595 112.492 63.094 113.213 63.0298C113.934 62.9657 114.728 63.2722 115.054 63.9187C116.025 65.8492 111.929 69.2143 110.806 70.5003C109.023 72.5397 107.522 74.8245 106.35 77.2671C106.038 77.9177 105.715 79.1365 105.242 80.2382Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M128.635 104.216C127.369 104.192 126.162 103.667 125.282 102.754L112.981 89.9925C111.149 88.0926 111.205 85.0675 113.105 83.2358C115.006 81.4041 118.03 81.4601 119.862 83.36L128.848 92.6826L147.267 74.9274C149.167 73.0957 152.192 73.1517 154.024 75.0516C155.855 76.9516 155.799 79.9766 153.899 81.8083L132.041 102.88C131.127 103.758 129.903 104.239 128.635 104.216Z",
    fill: "#E2E7F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1515_3766",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-208.127 64.725) scale(387.137 387.137)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6262,
    stopColor: "#BED8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6284,
    stopColor: "#C1DADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6485,
    stopColor: "#D7E7E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6705,
    stopColor: "#E7F1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6955,
    stopColor: "#F0F6F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7302,
    stopColor: "#F3F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8171,
    stopColor: "#F3F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8246,
    stopColor: "#F3F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8491,
    stopColor: "#EAF3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8889,
    stopColor: "#D2E4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9152,
    stopColor: "#BED8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9464,
    stopColor: "#B9D2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9878,
    stopColor: "#ABC1C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6BBBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1515_3766",
    x1: 88.7934,
    y1: 0.0294899,
    x2: 88.7934,
    y2: 140.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BED8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2142,
    stopColor: "#F3F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8243,
    stopColor: "#BED8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9143,
    stopColor: "#B2CACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9878,
    stopColor: "#A6BBBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1515_3766",
    x1: 56.9997,
    y1: 116.94,
    x2: 56.9997,
    y2: 154.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BED8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0269,
    stopColor: "#C2DBDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174,
    stopColor: "#D6E7E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2746,
    stopColor: "#DDEBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3967,
    stopColor: "#D4E6E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5844,
    stopColor: "#BED8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#AECCD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9099,
    stopColor: "#85ACBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9983,
    stopColor: "#729EB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1515_3766",
    x1: 188.524,
    y1: 6.30621,
    x2: 84.7409,
    y2: 149.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0365,
    stopColor: "#D5E4E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0912,
    stopColor: "#C8DDDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1616,
    stopColor: "#C0D9DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3014,
    stopColor: "#BED8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3956,
    stopColor: "#ABC9CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5863,
    stopColor: "#79A3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6111,
    stopColor: "#729EB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6764,
    stopColor: "#93B7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7683,
    stopColor: "#BED8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8702,
    stopColor: "#C0D9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9269,
    stopColor: "#C8DEE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9722,
    stopColor: "#D6E5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3ECF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1515_3766",
    x1: 99.4892,
    y1: 18.179,
    x2: 99.4892,
    y2: 36.1885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1413,
    stopColor: "#A6BBBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1587,
    stopColor: "#A9BEC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2752,
    stopColor: "#B8D1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3567,
    stopColor: "#BED8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4731,
    stopColor: "#BAD3D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6036,
    stopColor: "#AFC6C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6766,
    stopColor: "#A6BBBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7373,
    stopColor: "#9CAFB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8458,
    stopColor: "#809093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8983,
    stopColor: "#717F82"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1515_3766",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.3973 24.8746) scale(7.99119 7.99119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3183FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2260BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1515_3766",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.4462 46.9439) scale(7.99119 7.99119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3183FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2260BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1515_3766",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.7958 69.0118) scale(7.99119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3183FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2260BE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1515_3766",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.1337 91.0801) scale(7.99119 7.99119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3183FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2260BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1515_3766",
    x1: 92.5375,
    y1: 38.266,
    x2: 92.5375,
    y2: 58.2162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1413,
    stopColor: "#A6BBBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1587,
    stopColor: "#A9BEC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2752,
    stopColor: "#B8D1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3567,
    stopColor: "#BED8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4731,
    stopColor: "#BAD3D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6036,
    stopColor: "#AFC6C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6766,
    stopColor: "#A6BBBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7373,
    stopColor: "#9CAFB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8458,
    stopColor: "#809093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8983,
    stopColor: "#717F82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1515_3766",
    x1: 89.8873,
    y1: 61.6769,
    x2: 89.8873,
    y2: 79.1454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1413,
    stopColor: "#A6BBBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1587,
    stopColor: "#A9BEC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2752,
    stopColor: "#B8D1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3567,
    stopColor: "#BED8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4731,
    stopColor: "#BAD3D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6036,
    stopColor: "#AFC6C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6766,
    stopColor: "#A6BBBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7373,
    stopColor: "#9CAFB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8458,
    stopColor: "#809093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8983,
    stopColor: "#717F82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1515_3766",
    x1: 85.9155,
    y1: 82.5956,
    x2: 85.9155,
    y2: 102.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1413,
    stopColor: "#A6BBBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1587,
    stopColor: "#A9BEC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2752,
    stopColor: "#B8D1D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3567,
    stopColor: "#BED8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4731,
    stopColor: "#BAD3D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6036,
    stopColor: "#AFC6C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6766,
    stopColor: "#A6BBBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7373,
    stopColor: "#9CAFB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8458,
    stopColor: "#809093"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8983,
    stopColor: "#717F82"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1515_3766",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(127.478 86.703) rotate(7.19822) scale(48.6822)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00581592,
    stopColor: "#75D982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1298,
    stopColor: "#71D17A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4658,
    stopColor: "#67BF67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7358,
    stopColor: "#51AA59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8379,
    stopColor: "#48A153"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9301,
    stopColor: "#4AA354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9634,
    stopColor: "#51A959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.987,
    stopColor: "#5CB560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67BF67"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1515_3766",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.608 82.2827) scale(46.8478)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3183FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2260BE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateAssessment);
export default __webpack_public_path__ + "static/media/CreateAssessment.267e4ebd8ca395c13563bf1dec8e47bb.svg";
export { ForwardRef as ReactComponent };